import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Redirect } from "react-router"
import { routePaths } from "../.."
import { failMessage } from "../../../Actions/Client/MessagesActions"
import { AppCollaboratorsSignUp } from "../../../Components/Views/Dashboard/Sections/AppDetail/Collaborators/AppCollaboratorsSignUp"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppCollaboratorsSignUpRoute({
    match,
    location
}: AppDetailRouteComponentProps<{ collaborationID: string }>) {
    const search = new URLSearchParams(location.search)
    const code = search.get("verification_code")
    const collaborationId = Number.parseInt(match.params.collaborationID, 10)
    const dispatch = useDispatch()

    useEffect(() => {
        if (Number.isNaN(collaborationId) || code === null) {
            dispatch(failMessage("Sign up url is invalid"))
        }
    }, [code, dispatch, collaborationId])

    if (Number.isNaN(collaborationId) || code === null) {
        return <Redirect to={routePaths.home()} />
    }

    return (
        <AppCollaboratorsSignUp
            appId={match.params.appID}
            orgUsername={match.params.orgUsername}
            collaborationId={collaborationId}
            code={code}
        />
    )
}
